const attendanceOptions = [
  {
    "key": "ATTENDED",
    "text": "Attended"
  },
  {
    "key": "UNATTENDED",
    "text": "Unattended"
  },
];

export default attendanceOptions;